var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('announcement'),_c('div',{staticClass:"container"},[_c('div',{staticClass:"member-wrapper"},[_c('memberMenu'),(_vm.accountGroup === 'WI')?[_c('depositWI')]:[_c('depositMU')]],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }